<div class="stravaRecord">
  <img
    class="achImage"
    [src]="'assets/images/medal_' + achievement.rank + '.png'"
  />
  Congrats! You just set your {{achievement.rank===1 ? 'PR': achievement.rank ===2 ? '2nd fastest time' : '3rd fastest time'}} in the {{achievement.name}} !
</div>